<template>
    <el-card>
        <template #header>
            <content-header />
        </template>
        <div class="header-button">
            <search-form ref="searchForm" :fields="search" />
            <div class="selections">
                <el-button type="primary" @click="addWorker"
                    >添加地勤人员
                </el-button>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" title="地勤人员" width="25%">
            <lz-form
                ref="form"
                :disable-redirect="true"
                :edit-mode="isedit"
                :errors.sync="errors"
                :in-dialog="true"
                :model="form"
                :rules="rules"
                :submit="onSubmit"
                label-width="80px"
                style="margin: 10px 0"
            >
                <el-form-item label="工号" prop="job_number" required>
                    <el-input
                        v-model="form.job_number"
                        class="limitwidth"
                        maxlength="6"
                        onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
                        show-word-limit
                    />
                </el-form-item>
                <el-form-item label="姓名" prop="name" required>
                    <el-input v-model="form.name" class="limitwidth" />
                </el-form-item>
                <el-form-item
                    label="账号"
                    prop="account"
                    required
                    style="margin: 0"
                >
                    <el-input v-model="form.account" class="limitwidth" />
                    <p class="help-info">
                        !密码默认为123456789，可在运维端自行修改
                    </p>
                </el-form-item>
                <el-form-item label="手机号" prop="phone" required>
                    <el-input v-model="form.phone" class="limitwidth" />
                </el-form-item>
                <el-form-item label="负责区域" prop="area_id" required>
                    <el-select
                        v-model="form.area_id"
                        class="limitwidth"
                        clearable
                        multiple
                        filterable
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in areas"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="角色" prop="yunwei_role" required>
                    <el-select
                        v-model="form.yunwei_role"
                        class="limitwidth"
                        clearable
                        filterable
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in workerRoles"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="运维端" prop="is_login_app" required>
                    <el-radio v-model="form.is_login_app" label="1"
                        >正常使用
                    </el-radio>
                    <el-radio v-model="form.is_login_app" label="0"
                        >禁用
                    </el-radio>
                </el-form-item>
                <el-form-item label="状态" prop="status" required>
                    <el-radio v-model="form.status" label="1">正常 </el-radio>
                    <el-radio v-model="form.status" label="0">停用 </el-radio>
                </el-form-item>
            </lz-form>
            <!-- <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="onSubmit">确 定</el-button>
            </span> -->
        </el-dialog>

        <el-table :data="users" resource="worker">
            <el-table-column label="账号" prop="account" width="180" />
            <el-table-column label="姓名" prop="name" width="180" />
            <el-table-column label="工号" prop="job_number" width="120" />
            <el-table-column label="手机号" prop="phone" width="120" />

            <el-table-column label="负责区域" prop="area_name" />
            <el-table-column align="center" label="运维端" width="80">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.is_login_app" type="success"
                        >正常使用
                    </el-tag>
                    <el-tag v-else type="danger">禁用 </el-tag>
                </template>
            </el-table-column>

            <el-table-column align="center" label="角色" width="80">
                <template slot-scope="scope">
                    <el-tag type="success">
                        {{
                            workerRoles[scope.row.yunwei_role]
                                ? workerRoles[scope.row.yunwei_role]["name"]
                                : "--"
                        }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column align="center" label="状态" width="80">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status" type="success"
                        >正常
                    </el-tag>
                    <el-tag v-else type="danger">停用 </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="添加时间" prop="created_at" width="180" />
            <el-table-column label="操作" width="300">
                <template #default="{ row, $index }">
                    <row-destroy />
                    <el-button
                        size="small"
                        type="success"
                        @click="editRow(row)"
                    >
                        编辑
                    </el-button>
                    <el-button
                        size="small"
                        type="primary"
                        @click="resetClick(row)"
                    >
                        重置
                    </el-button>

                    <button-link :to="link(row)" size="small" type="success">
                        <slot>绩效</slot>
                    </button-link>
                </template>
            </el-table-column>
        </el-table>
        <div class="card-footer">
            <pagination :page="page" />
        </div>
        <el-dialog
            :visible.sync="resetPasswordDialogVisible"
            title="提示"
            width="30%"
        >
            <span>确认重置密码吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetPasswordDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="resetPassword()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </el-card>
</template>

<script>
import LzForm from "@c/LzForm";
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import {
    getWorkers,
    storeWorker,
    updateWorker,
    resetWorker,
    getWorkerRoles,
} from "@/api/workers";
import { getAreas } from "@/api/area";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import FormHelper from "@c/LzForm/FormHelper";
import ButtonLink from "@c/ButtonLink";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
    name: "Index",
    components: {
        LzForm,
        RowToEdit,
        RowDestroy,
        SearchForm,
        Pagination,
        ButtonLink,
    },
    mixins: [FormHelper],
    data() {
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            } else {
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error("请输入正确的手机号"));
                }
            }
        };
        return {
            search: [
                {
                    type: "el-select",
                    field: "area_id",
                    label: "骑行区域",
                    options: [
                        {
                            id: "",
                            name: "全部",
                        },
                    ],
                },
                {
                    type: "el-select",
                    field: "status",
                    label: "状态",
                    options: [
                        {
                            id: "",
                            name: "全部",
                        },
                        {
                            id: "1",
                            name: "正常",
                        },
                        {
                            id: "0",
                            name: "停用",
                        },
                    ],
                },
                {
                    field: "name",
                    label: "姓名",
                },
                {
                    field: "account",
                    label: "账号",
                },
                {
                    field: "phone",
                    label: "手机号",
                },
                {
                    field: "job_number",
                    label: "工号",
                },
            ],
            form: {
                id: "",
                job_number: "",
                name: "",
                account: "",
                phone: "",
                area_id: [],
                status: "1",
                yunwei_role: "1",
                is_login_app: "1",
            },
            users: [],
            page: null,
            areas: [],
            workerRoles: [],
            dialogVisible: false,
            rules: {
                phone: [{ validator: checkPhone, trigger: "blur" }],
                job_number: [
                    {
                        min: 3,
                        max: 6,
                        message: "长度在 3 到 6个字符",
                        trigger: "blur",
                    },
                ],
            },
            errors: {},
            isedit: false,
            resetPasswordDialogVisible: false,
            reset_id: "",
        };
    },
    inject: ["reload"],
    watch: {
        $route: {
            async handler(newVal) {
                const {
                    data: { data, meta },
                } = await getWorkers(newVal.query);
                this.users = data;
                this.page = meta;
            },
            immediate: true,
        },
    },
    async created() {
        // console.log(11)
        const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);
        const [{ data: workerRoles }] = await Promise.all([getWorkerRoles()]);

        this.workerRoles = workerRoles;
        this.areas.push.apply(this.areas, areas);
        this.search[0].options.push.apply(this.search[0].options, areas);
        if (this.$store.state.users.user.roles[0] === "administrator") {
            const [{ data: merchant }] = await Promise.all([
                getAdminUsersMerchant({ all: 1 }),
            ]);
            if (env.isPosSwitch == true) {
                this.search.push({
                    type: "el-select",
                    field: "merchant_id",
                    label: "商户",
                    options: [
                        {
                            id: "",
                            name: "全部",
                        },
                    ],
                });
                this.search[6].options.push.apply(
                    this.search[6].options,
                    merchant.data
                );
            }
        }
    },
    methods: {
        link(row) {
            return `/worker/achievements?worker_id=` + row.id;
        },
        addWorker() {
            this.form.job_number = "";
            this.form.name = "";
            this.form.phone = "";
            this.form.account = "";
            this.form.status = "1";
            this.form.area_id = [];
            this.form.is_login_app = "1";
            this.form.yunwei_role = "";
            this.isedit = false;
            this.dialogVisible = true;
        },
        editRow(row) {
            // 编辑
            this.isedit = true;
            this.form.id = row.id;
            this.form.job_number = row.job_number;
            this.form.name = row.name;
            this.form.phone = row.phone;
            this.form.account = row.account;
            this.form.yunwei_role = row.yunwei_role;
            this.form.status = String(row.status);
            this.form.area_id = row.area_id;
            this.form.is_login_app = String(row.is_login_app);
            this.dialogVisible = true;
        },
        async onSubmit() {
            if (this.isedit) {
                await updateWorker(this.form.id, this.form);
                this.reload();
            } else {
                this.dialogVisible = false;
                delete this.form.id;
                await storeWorker(this.form);
                this.reload();
            }
        },
        resetClick(row) {
            this.reset_id = row.id;
            this.resetPasswordDialogVisible = true;
        },
        resetPassword() {
            var params = { id: this.reset_id };
            resetWorker(params).then((res) => {
                res.then((data) => {
                    if (data) {
                        this.$message({
                            showClose: true,
                            message: "重置成功",
                            type: "success",
                        });
                    }
                });
            });
            this.resetPasswordDialogVisible = false;
        },
    },
};
</script>
<style lang="scss" scope>
.header-button {
    display: flex;
    justify-content: space-between;

    .selections {
        display: inline-block;
        margin-right: 10px;
    }
}
.help-info {
    font-size: 12px;
    margin: 0;
    padding: 0;
}
.limitwidth {
    // width: 40% !important;
    //margin-right: 10px;
}
</style>
